<label class="single-ctrl-top-space">&nbsp;</label>
<div class="ms-2" matTooltip="{{this.field.toolTipText}}"  [matTooltipPosition]="'above'">  
  <label [formGroup]="form" style="line-height: 20px; margin: 0;display: flex; flex-wrap: wrap;align-items: center;">
    <!--<input type="checkbox" [formControlName]="field.controlName" [name]="field.controlName" [id]="field.controlName" style="margin-right:5px" class="k-checkbox" />
  <span class="k-checkbox-label" [innerHTML]="field.labelText"></span>-->
    <!--Include retired and unassigned modules-->

    <mat-checkbox *ngFor="let option of filteredDataSource | async" color="primary" [formControlName]="field.controlName" [name]="field.controlName" [id]="field.controlName">{{option.Text}}</mat-checkbox>
    <span class="icon-info ps-2 mt-1"></span>
  </label>
</div>
